import { AppModule } from 'app/module';
import { mediaQueries } from 'util/mediaQueries';
import 'module/checkbox/main';
import Template from './template.hbs';
import './styles.scss';

export class CompaniesFilter extends AppModule {
    setTemplate() {
        this.template = Template;
        if (module.hot) {
            module.hot.accept('./template.hbs', () => {
                this.template = Template;
                this.render();
            });
        }
    }

    domBindings() {
        return {
            checkboxes: ['[type="checkbox"]'],
            radios: ['[type="radio"]'],
            stateCheckboxes: ['.m-checkbox__input[name^=states]'],
            countryCheckboxes: ['.m-checkbox__input[name^=countries]'],
            overlayOpenTrigger: '.m-companiesFilter__overlayOpenTrigger',
            overlayCloseTrigger: '.m-companiesFilter__overlayCloseTrigger',
            groups: '.m-companiesFilter__groups',
            groupHeaders: ['.m-companiesFilter__groupHeader'],
            resetButton: '.m-companiesFilter__resetButton',
        };
    }

    domEvents() {
        for (let i = 0; i < this.dom.checkboxes.length; i += 1) {
            this.dom.checkboxes[i].addEventListener('change', (e) => this.changedFilter(e));
        }
        for (let i = 0; i < this.dom.radios.length; i += 1) {
            this.dom.radios[i].addEventListener('change', (e) => this.changedFilter(e));
        }
        this.dom.el.addEventListener('submit', (e) => this.submitForm(e));
        this.dom.resetButton.addEventListener('click', (e) => {
            e.preventDefault();
            this.resetForm();
        });

        for (let i = 0; i < this.dom.groupHeaders.length; i += 1) {
            this.dom.groupHeaders[i].addEventListener('click', (e) => this.changedAccordion(e));
        }

        if (this.dom.overlayOpenTrigger) {
            this.dom.overlayOpenTrigger.addEventListener('click', () => this.openOverlay());
        }
        if (this.dom.overlayCloseTrigger) {
            this.dom.overlayCloseTrigger.addEventListener('click', () => this.closeOverlay());
        }

        mediaQueries.events.on('changed', () => {
            if (!mediaQueries.isMobile()) {
                this.closeOverlay();
            }
        });
    }

    getFilterGroupsList() {
        if (!this.filterGroupsList) {
            const inputs = this.dom.el.querySelectorAll('[type="checkbox"]');
            this.filterGroupsList = [].reduce.call(inputs, (names, input) => {
                let { name } = input;
                if (input.name.slice(-2) === '[]') {
                    name = input.name.slice(0, -2);
                }
                if (names.indexOf(name) === -1) {
                    names.push(name);
                }
                return names;
            }, []);
        }
        return this.filterGroupsList;
    }

    getPropsFromDom() {
        const filter = this.serializeFilter();
        const display = this.getDisplayProps(filter);
        return { ...filter, display };
    }

    // This is a public function for communicating with the jobs search.
    updateCompaniesSearchProps(searchRequest, render) {
        const defaultProps = {};
        this.getFilterGroupsList().forEach((group) => {
            defaultProps[group] = [];
        });
        const props = {
            ...defaultProps,
            ...searchRequest,
            display: this.getDisplayProps(searchRequest) };
        return this.setProps(props, render);
    }

    // This is a public function is for communicating with the jobs search.
    getCompaniesSearchProps() {
        const props = this.getProps();
        delete props.display;
        return props;
    }

    getDisplayProps(filter) {
        const oldDisplayProps = this.getProps().display;
        const newDisplayProps = {};

        function getCount(group) {
            if (filter[group] === Object(filter[group])) {
                return filter[group] ? Object.keys(filter[group]).length : 0;
            }
            return filter[group] === true ? 1 : 0;
        }

        function getOpen(group) {
            return oldDisplayProps ? oldDisplayProps[group].open : !mediaQueries.isMobile();
        }

        function getTouched(group) {
            return oldDisplayProps ? oldDisplayProps[group].touched : !mediaQueries.isMobile();
        }

        newDisplayProps.all = {
            count: this.getFilterGroupsList().reduce((count, group) => count + getCount(group), 0),
            open: getOpen('all'),
            touched: getTouched('all'),
        };

        this.getFilterGroupsList().forEach((group) => {
            newDisplayProps[group] = {
                count: getCount(group),
                open: getOpen(group),
                touched: getTouched(group),
            };
        });

        newDisplayProps.sort = {
            open: getOpen('sort'),
        };

        return newDisplayProps;
    }

    changedFilter(e) {
        if (this.isStateCheckbox(e.currentTarget)) {
            this.resetCountries();
        }

        if (this.isCountryCheckbox(e.currentTarget)) {
            this.resetStates();
        }

        const filter = this.serializeFilter();
        const display = this.getDisplayProps(filter);
        const props = { ...filter, display };

        this.updateProps(props, true);

        if (!mediaQueries.isMobile()) {
            this.submitFilter();
        }
    }

    changedAccordion(e) {
        const props = this.getProps();
        Object.entries(props.display).forEach(([, value]) => {
            value.touched = false;
        });
        if (e.currentTarget.parentNode.querySelector('[type="radio"]')) {
            props.display.sort.open = !props.display.sort.open;
        } else {
            let prop = e.currentTarget.parentNode.querySelector('[type="checkbox"]').name;
            if (prop.slice(-2) === '[]') {
                prop = prop.slice(0, -2);
            }
            props.display[prop].touched = true;
            props.display[prop].open = !props.display[prop].open;
        }
        this.updateProps(props, true);
    }

    isStateCheckbox($el) {
        return [].indexOf.call(this.dom.stateCheckboxes, $el) !== -1;
    }

    isCountryCheckbox($el) {
        return [].indexOf.call(this.dom.countryCheckboxes, $el) !== -1;
    }

    resetStates() {
        for (let i = 0; i < this.dom.stateCheckboxes.length; i += 1) {
            this.dom.stateCheckboxes[i].checked = false;
        }
    }

    resetCountries() {
        for (let i = 0; i < this.dom.countryCheckboxes.length; i += 1) {
            this.dom.countryCheckboxes[i].checked = false;
        }
    }

    submitForm(e) {
        e.preventDefault();

        this.submitFilter();
        this.closeOverlay();
    }

    resetForm() {
        for (let i = 0; i < this.dom.checkboxes.length; i += 1) {
            this.dom.checkboxes[i].checked = false;
        }

        this.updateProps({
            keywords: '', locations: '', locationSlug: '', ...this.getPropsFromDom(), ...true });

        this.updateProps(this.getPropsFromDom(), true);
        this.events.emit('resetCompaniesSearchForm');
        this.submitFilter();
        this.closeOverlay();
    }

    submitFilter() {
        this.events.emit('changed', this.getProps());
    }

    serializeFilter() {
        const $inputs = this.dom.el.elements;
        const inputsLength = $inputs.length;
        const formData = {};
        let i;

        for (i = 0; i < inputsLength; i += 1) {
            const $input = $inputs[i];

            const isFormArray = ($input.name.substr($input.name.length - 2) === '[]');
            if (isFormArray) {
                // checkboxes
                const arrayName = $input.name.substr(0, $input.name.length - 2);

                // create empty if not exist
                if (!(formData[arrayName] instanceof Object)) {
                    formData[arrayName] = {};
                }
                if ($input.checked === true) {
                    formData[arrayName][$input.value] = true;
                }
            } else if ($input.checked === true) {
                if ($input.value === 'true') {
                    formData[$input.name] = true;
                } else {
                    formData[$input.name] = $input.value;
                }
            } else if (!{}.hasOwnProperty.call(formData, $input.name)) {
                // create empty if not exist
                formData[$input.name] = false;
            }
        }

        return formData;
    }

    openOverlay() {
        const props = this.getProps();
        props.display.all.open = true;
        this.updateProps(props, true);
    }

    closeOverlay() {
        const props = this.getProps();
        props.display.all.open = false;
        this.updateProps(props, true);
    }
}
